export default (context, keyword) => {
    context.commit('setKeyword', keyword);
    context.dispatch('saveState');
    context.dispatch('getData');
}



// WEBPACK FOOTER //
// ./src/app/store/base/actions/search-keyword.js